/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import { MeshLambertMaterial, DoubleSide } from 'three';
import * as topojson from 'topojson-client';
import Globe from 'globe.gl';

const world = new Globe(document.querySelector(".ew-globe-block"))
	.backgroundColor('rgba(0,0,0,0)')
	.showGlobe(true)
	.enablePointerInteraction(false)
	.showAtmosphere(false)
	.globeMaterial(new MeshLambertMaterial({ color: '#003866', transparent: true , opacity: 0.5 }))
	.width(document.querySelector('.wp-block-create-block-ew-globe').offsetWidth*1.8)
	.height(document.querySelector('.wp-block-create-block-ew-globe').offsetWidth*1.8);

fetch('//cdn.jsdelivr.net/npm/world-atlas/land-110m.json')
	.then(res => res.json())
	.then(landTopo => {
		world
			.polygonsData(topojson.feature(landTopo, landTopo.objects.land).features)
			// .polygonCapMaterial(new MeshLambertMaterial({ color: 'darkslategrey', side: DoubleSide }))
			.polygonCapMaterial(new MeshLambertMaterial({ color: '#93c8f6', side: DoubleSide }))
			.polygonSideColor(() => 'rgba(0,0,0,0)');
			// .polygonAltitude(0.002);
		world.controls().enableZoom = false;
		world.controls().autoRotate = true;
		world.controls().autoRotateSpeed = 0.7;
		// world.animateIn = false;
		// world.globeOffset()
		world.camera().position.setZ(250);

	});



/* eslint-disable no-console */
// console.log("Hello World! (from create-block-ew-globe block)");
/* eslint-enable no-console */
